import UnapprovedCreditNoteList from "./UnapprovedCreditNoteList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "unapprovedCreditNotes",
  list: UnapprovedCreditNoteList,
};
